// extracted by mini-css-extract-plugin
export default {"container":"TaskList_container__TmeWg","header":"TaskList_header__uRGnX","line":"TaskList_line__nJzV+","taskList":"TaskList_taskList__gJ6M0"};